<bricks-modal (closeDialog)="closeDialog()">
  <bricks-modal-header class="text-header">EEG-Förderung endet während der Vertragslaufzeit</bricks-modal-header>
  <bricks-modal-body>
    <p>
      Nach dem Erneuerbare-Energien-Gesetz (EEG) ist die Förderung auf einen festen Zeitraum von 20 Jahren ab der
      Inbetriebnahme Ihrer Anlage begrenzt. Das von Ihnen angegebene Inbetriebnahmedatum führt dazu, dass die
      EEG-Förderung während der gewählten Vertragslaufzeit ausläuft.
      <br />
      <br />
      Sie haben nun folgende Möglichkeiten:
    </p>
    @if (this.data.validContractEndDate) {
      <div class="text-grey">
        <p>
          Das Datum des gewünschten Vertragsendes so wählen, dass es vor oder zum Ende Ihrer EEG-Förderung liegt (=
          geförderte Direktvermarktung).
        </p>
        <br />
        <div class="date-row">
          <div class="date-block">
            <span class="adjustment-label">aktueller Wert</span>
            <span class="adjustment-value">{{ this.data.contractEndDate | dateDayMonthYear }}</span>
          </div>
          <div>
            <bricks-icon>bricks-arrow-right</bricks-icon>
          </div>
          <div class="date-block">
            <span class="adjustment-label">neuer Wert</span>
            <span class="adjustment-value">{{ this.data.validContractEndDate | dateDayMonthYear }}</span>
          </div>
        </div>
        <button
          class="bricks-button button-primary button-fn"
          (click)="closeDialog(ContractAdjustmentOption.AdjustEndDate)">
          <span>Vertragslaufzeit anpassen</span>
        </button>
      </div>
      <br />
    }
    @if (this.showStartDateOption) {
      <div class="text-grey">
        <p>
          Das Datum des gewünschten Direktvermarktungs-Starts so wählen, dass es nach dem Ende Ihrer EEG-Förderung
          liegt. (= sonstige Direktvermarktung/Post-EGG)
        </p>
        <br />
        <div class="date-row">
          <div class="date-block">
            <span class="adjustment-label">aktueller Wert</span>
            <span class="adjustment-value">{{ this.data.contractStartDate | dateDayMonthYear }}</span>
          </div>
          <div>
            <bricks-icon>bricks-arrow-right</bricks-icon>
          </div>
          <div class="date-block">
            <span class="adjustment-label">neuer Wert</span>
            <span class="adjustment-value">{{ this.data.validContractStartDate | dateDayMonthYear }}</span>
          </div>
        </div>
        <button
          class="bricks-button button-primary button-fn"
          (click)="closeDialog(ContractAdjustmentOption.AdjustStartDate)">
          <span>Direktvermarktungs-Start ändern</span>
        </button>
      </div>
    }
    <br />
    <div class="text-grey">
      <p>
        Die Sonstige Direktvermarktung (ungefördert sowie Post-EEG) wählen auch für den Zeitraum mit EEG-Förderung.
        Bewusster Verzicht auf Marktprämie.
      </p>
      <br />
      <div class="date-row">
        <div class="date-block">
          <span class="adjustment-label">aktueller Wert</span>
          <span class="adjustment-value">EEG-Direktvermarktung</span>
        </div>
        <div>
          <bricks-icon>bricks-arrow-right</bricks-icon>
        </div>
        <div class="date-block">
          <span class="adjustment-label">neuer Wert</span>
          <span class="adjustment-value">Sonstige Direktvermarktung</span>
        </div>
      </div>
      <button
        class="bricks-button button-primary button-fn"
        (click)="closeDialog(ContractAdjustmentOption.ChangeMarketingType)">
        <span>Direktvermarktungform ändern</span>
      </button>
    </div>
  </bricks-modal-body>
  <bricks-modal-footer>
    <button class="bricks-button button-primary button-fn" (click)="closeDialog()">
      <span>Abbrechen</span>
    </button>
  </bricks-modal-footer>
</bricks-modal>
